import { Col, Typography } from "@commonlibs";
import { RadioButtonGroup } from "ui/common/components/input/RadioButtonGroup/RadioButtonGroup";
import { ReleaseStrategySelectorProps } from "./ReleaseStrategySelector.types";
import { ReleaseType } from "../ModifyMovements.types";

export default function ReleaseStrategySelector({ selectedOperation, onChangeRelease }: ReleaseStrategySelectorProps) {
    const releaseTypes = [
        { label: "Email informativo", value: "email" },
        { label: "Envío de OTP", value: "otp" },
        { label: "No Aplica", value: "N/A" },
    ];

    return (
        <Col gap={15}>
            <Typography variant="body2Strong">Tipo de liberación</Typography>
            <RadioButtonGroup
                key={selectedOperation?.release}
                onChange={(value) => onChangeRelease(value as ReleaseType)}
                defaultValue={selectedOperation?.release}
                direction="column"
                options={releaseTypes}
            />
        </Col>
    );
}
